import * as angular from "angular";
import * as _ from "lodash";
import AddBatchFormulaName, {openAddBatchFormula} from "./addBatchFormula.controller";
import UpdateBatchFormulaName, {openUpdateBatchFormula} from "./updateBatchFormula.controller";
import {States} from "../../shared/config/constant.module";
import template from './batchFormulas.tpl.html';
import {Plant} from "../../models/navigation";
import {apsCommon} from "../../shared/dto/aps.common";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import BatchFormulasServiceName, {BatchFormulasService} from "../../services/batches/batchFormulas.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import JobServiceName, {JobService} from "../../services/jobs/job.service";
import CommoditiesServiceName, {CommoditiesService} from "../../services/batches/commodities.service";

let requires = [AddBatchFormulaName, UpdateBatchFormulaName, LoaderServiceName, NotifyServiceName, BatchFormulasServiceName,
  AuthDataServiceName, UIUtilityServiceName, NavigationServiceName, JobServiceName, CommoditiesServiceName];

interface BatchFormulasController {
  batchFormulas: apsViewModels.BatchFormulaItem[];
  plants: Plant[];
  selectedPlant: Plant;
  plantChanged(): void;
  add(): void;
  edit(instance: apsViewModels.BatchFormulaItem): void;
  remove(instance: apsViewModels.BatchFormulaItem): void;
}

class BatchFormulasCtrl implements BatchFormulasController {
  batchFormulas: apsViewModels.BatchFormulaItem[];
  plants: Plant[];
  selectedPlant: Plant;
  glassColors: apsCommon.IdAndName[];
  commodities: apsViewModels.CommodityItem[];

  private loaderService: LoaderService;
  private batchFormulasService: BatchFormulasService;
  private commoditiesService: CommoditiesService;
  private uiUtilityService: UIUtilityService;
  private notifyService: NotifyService;
  private $modal: mm.foundation.modal;
  private $q: angular.IQService;

  constructor(
    loaderService: LoaderService,
    batchFormulasService: BatchFormulasService,
    commoditiesService: CommoditiesService,
    jobService: JobService,
    $q: angular.IQService,
    navigationService: NavigationService,
    authDataService: AuthDataService,
    uiUtilityService: UIUtilityService,
    notifyService: NotifyService,
    $modal: mm.foundation.modal
  ) {
    this.loaderService = loaderService;
    this.batchFormulasService = batchFormulasService;
    this.commoditiesService = commoditiesService;
    this.uiUtilityService = uiUtilityService;
    this.notifyService = notifyService;
    this.$modal = $modal;
    this.$q = $q;

    let promises = [];
    promises.push(navigationService.getNavigation().then(nav => {
      let plants = nav.plants();
      this.plants = _.filter(plants, (plant: Plant) => {
        return authDataService.isAPSIOAdminForPlant(plant.id);
      });

      if (nav.selectedPlant && _.includes(this.plants, nav.selectedPlant)) {
        this.selectedPlant = nav.selectedPlant;
      } else {
        this.selectedPlant = _.first(this.plants);
      }

      return this.loadBatchFormulas();
    }));

    promises.push(jobService.getGlassColors().then(colors => this.glassColors = colors));

    this.loaderService.loadingPromise(this.$q.all(promises));
  }

  private loadBatchFormulas(): angular.IPromise<any> {
    let promises = [];

    promises.push(this.batchFormulasService
      .get(this.selectedPlant.id)
      .then(batchFormulas => this.batchFormulas = batchFormulas));

    promises.push(this.commoditiesService
      .get(this.selectedPlant.id)
      .then(commodities => this.commodities = commodities));

    return this.$q.all(promises);
  }

  plantChanged(): void {
    this.loaderService.loadingPromise(this.loadBatchFormulas());
  }

  add(): void {
    let result = openAddBatchFormula({
      plant: this.selectedPlant,
      allBatchFormulas: this.batchFormulas,
      commodities: this.commodities,
      glassColors: this.glassColors
    }, this.$modal);

    result.then(instance => {
      if (!instance) {
        return;
      }

      this.batchFormulas.push(instance);
    });
  }

  edit(instance: apsViewModels.BatchFormulaItem): void {
    this.batchFormulasService.getDetail(instance.plantId, instance.id)
      .then(detail => {
        let result = openUpdateBatchFormula({
          instance: detail,
          allBatchFormulas: this.batchFormulas,
          commodities: this.commodities,
          glassColors: this.glassColors
        }, this.$modal);

        result.then(updated => {
          if (!updated) {
            return;
          }

          _.remove(this.batchFormulas, instance);
          this.batchFormulas.push(updated);
        });
      });
  }

  remove(instance: apsViewModels.BatchFormulaItem): void {
    this.uiUtilityService.confirm('Are you sure you want to delete this Formula?').then(confirmed => {
      if (!confirmed) {
        return;
      }

      this.loaderService.loadingPromise(this.batchFormulasService.remove({
        id: instance.id,
        plantId: this.selectedPlant.id
      }).then(() => {
        _.remove(this.batchFormulas, instance);
      }, this.notifyService.handleApiErrors));
    });
  }
}

export default angular.module('aps.controller.batchFormulas', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.BATCH_FORMULAS,
      url: '/admin/batchFormulas',
      controller: 'BatchFormulasCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Batch Formulas',
        authorizeAPSIOAdmin: true
      }
    });
  })
  .controller('BatchFormulasCtrl', BatchFormulasCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/batchFormulas.controller.ts